<template>
   <section class="login-content">
      <div class="container">
         <div class="row align-items-center justify-content-center height-self-center">
            <div class="col-lg-8">
               <div class="card auth-card">
                  <div class="card-body p-0">
                     <div class="d-flex align-items-center auth-content">
                        <div class="col-lg-7 align-self-center">
                           <div class="p-3">
                              <h2 class="mb-2">비밀번호 찾기</h2>
                              <p>가입하신 이메일 주소를 입력하시면<br>임시 비밀번호를 발급해드립니다.</p>

                              <!-- 성공 메시지 -->
                              <div v-if="successMessage" class="alert alert-success" role="alert">
                                 <i class="ri-check-line mr-2"></i>{{ successMessage }}
                              </div>

                              <!-- 오류 메시지 -->
                              <div v-if="errorMessage" class="alert alert-danger" role="alert">
                                 <i class="ri-error-warning-line mr-2"></i>{{ errorMessage }}
                              </div>

                              <form @submit.prevent="onSubmit" v-if="!isSubmitted">
                                 <div class="row">
                                    <div class="col-lg-12">
                                       <div class="floating-label form-group">
                                          <input
                                             class="floating-input form-control"
                                             type="email"
                                             placeholder=" "
                                             v-model="email"
                                             :disabled="isLoading"
                                             required
                                          >
                                          <label>이메일 주소</label>
                                       </div>
                                    </div>
                                 </div>

                                 <button
                                    type="submit"
                                    class="btn btn-primary btn-block"
                                    :disabled="isLoading || !email"
                                 >
                                    <span v-if="isLoading">
                                       <i class="ri-loader-4-line spin mr-2"></i>처리 중...
                                    </span>
                                    <span v-else>
                                       <i class="ri-mail-send-line mr-2"></i>임시 비밀번호 발급
                                    </span>
                                 </button>

                                 <div class="mt-3 text-center">
                                    <router-link :to="{name: 'auth.login'}" class="text-primary">
                                       <i class="ri-arrow-left-line mr-1"></i>로그인으로 돌아가기
                                    </router-link>
                                 </div>
                              </form>

                              <!-- 발송 완료 후 안내 -->
                              <div v-if="isSubmitted" class="text-center">
                                 <div class="mb-4">
                                    <i class="ri-mail-check-line" style="font-size: 4rem; color: #28a745;"></i>
                                 </div>
                                 <h4 class="mb-3">이메일을 확인해주세요</h4>
                                 <p class="mb-4">
                                    <strong>{{ email }}</strong>로<br>
                                    임시 비밀번호를 발송했습니다.
                                 </p>
                                 <div class="alert alert-info">
                                    <small>
                                       <i class="ri-information-line mr-1"></i>
                                       이메일이 도착하지 않았다면 스팸함을 확인해주세요.<br>
                                       임시 비밀번호로 로그인 후 반드시 비밀번호를 변경해주세요.
                                    </small>
                                 </div>
                                 <div class="mt-4">
                                    <router-link
                                       :to="{name: 'auth.login'}"
                                       class="btn btn-primary"
                                    >
                                       로그인으로 이동
                                    </router-link>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-lg-5 content-right">
                           <img src="@/assets/images/login/01.png" class="img-fluid image-right" alt="">
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
import axios from 'axios'

export default {
   name: 'ForgotPassword',
   data() {
      return {
         email: '',
         isLoading: false,
         isSubmitted: false,
         successMessage: '',
         errorMessage: ''
      }
   },
   methods: {
      async onSubmit() {
         this.isLoading = true;
         this.errorMessage = '';
         this.successMessage = '';

         try {
            const response = await axios.post('/api/auth/forgot-password', {
               email: this.email.trim()
            });

            if (response.data.success) {
               this.successMessage = response.data.message;
               this.isSubmitted = true;
            } else {
               this.errorMessage = response.data.message || '요청 처리에 실패했습니다.';
            }

         } catch (error) {
            console.error('비밀번호 재설정 요청 오류:', error);

            if (error.response && error.response.data && error.response.data.message) {
               this.errorMessage = error.response.data.message;
            } else {
               this.errorMessage = '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
            }
         } finally {
            this.isLoading = false;
         }
      }
   }
}
</script>

<style scoped>
.spin {
   animation: spin 1s linear infinite;
}

@keyframes spin {
   from { transform: rotate(0deg); }
   to { transform: rotate(360deg); }
}

.alert {
   border-radius: 8px;
   border: none;
   padding: 15px;
}

.alert-success {
   background-color: #d4edda;
   color: #155724;
}

.alert-danger {
   background-color: #f8d7da;
   color: #721c24;
}

.alert-info {
   background-color: #d1ecf1;
   color: #0c5460;
}

.btn:disabled {
   opacity: 0.6;
   cursor: not-allowed;
}

.floating-label {
   position: relative;
}

.floating-input:focus + label,
.floating-input:not(:placeholder-shown) + label {
   transform: translateY(-1.5rem) scale(0.85);
   color: #007bff;
}

.floating-label label {
   position: absolute;
   top: 0.75rem;
   left: 0.75rem;
   transition: all 0.2s ease-in-out;
   pointer-events: none;
   color: #6c757d;
}
</style>
